import { useFormContext } from 'react-hook-form'
import LangInput from '@components/form/LangInput'

const ContextLangInput = ({ name, ...rest }) => {
    const methods = useFormContext()
    return <LangInput {...rest}
        name={name || 'jezyk'}
        methods={methods} />
}

export default ContextLangInput